import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import { 
  Avatar,
  Container, 
  Box, 
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  FormControlLabel,
  IconButton,
  InputLabel,
  ListItemText,
  ListItem,
  ListItemIcon,
  Fab,
  Grid,
  Paper,
  Typography, 
  Tooltip,
  Input,
  Icon,
  Toolbar,
  MenuItem,  
} from "@material-ui/core"
import SelectMaterial from "@material-ui/core/Select"
import { Autocomplete } from"@material-ui/lab"
import AddIcon from "@material-ui/icons/Add"
import TagIcon from '@material-ui/icons/Brightness1'
import GoogleMapLocation from "../../components/GoogleMapLocation"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import ImageSelector from '../../components/ImageSelector/ImageSelector'
import { actionSaveNotification } from '../../actions/NotificationActions'
import { actionGetTags } from "../../actions/TagActions"

import moment from 'moment'
let _handleSubmitFail;
class AddEditNotifications extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={imgEdit:null, imgNameEdit:null, tagsSelected:[]}
    this.onClean=this.onClean.bind(this)
    this.onSave=this.onSave.bind(this)
    this.onSelectTag=this.onSelectTag.bind(this)
    this.renderTags=this.renderTags.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    this.props.actionGetTags(null,(e)=>{console.log("ERROR AL LISTAR TAGS",e)})
    if(this.props.isEditing){
      let notification=this.props.history.location.state//this.props.notification
      console.log("NOTIFICATION", notification)
      if(notification){  
        notification.tskRunDate = notification.tskRunDate&&Util.timestampToMoment(notification.tskRunDate).format('YYYY-MM-DDTHH:mm')
        this.props.initialize(notification)
        notification.tskParams&&this.setState({imgEdit:notification.tskParams.image, imgNameEdit:notification.tskParams.nameImg, tagsSelected:notification.tskTags})
      }else{
        this.props.history.replace(LOGIN_ROUTE);
      }
    }else{
      this.props.initialize({tskStatus:"scheduled", tskTask:"notify", tskImmediate:false})
    }
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onClean(){
    let initNoti = {tskStatus:"scheduled", tskTask:"notify"}
    if(this.props.isEditing){
      let notification=this.props.notification
      if(notification.tskParams&&notification.tskParams.pathImg){
        initNoti.tskParams = {pathImg:notification.tskParams.pathImg}
      }
      this.props.initialize(initNoti)
      this.setState({imgEdit:null, imgNameEdit:null, tagsSelected:initNoti.tskTags})
    }else{
      this.props.initialize(initNoti)
      this.setState({imgEdit:null, imgNameEdit:null, tagsSelected:[]})
    }
    
  }

  onSave(formValues){
    this.props.actionSaveNotification({...formValues, tskTags:this.state.tagsSelected}
      , ()=>{Util.showNoty(SUCCESS, "La notificación se guardó correctamente."); this.props.history.goBack()}
      , (e)=>{
        console.log("ERROR ON SAVE NOTIFICATION", e)
        if(!(e&&e.status&&e.status==401)){
          if(e&&e.body&&e.body.notificationSendFail){
            Util.showNoty(ERROR, "Guardamos la notificación pero no se pudo enviar.")
          }else{
            Util.showNoty(ERROR, "No se pudo guardar la notificación.")
          }
        }
          
      }
    )
  }

  onSelectTag(evt, tag){
      let tags = tag.slice()
      this.setState({tagsSelected:tags})
  }

  renderTags(tags){
    console.log("RENDER TAGS",tags);
    let t = tags&&tags.filter((t)=>!t.add)
    return t&&t.map((tag)=><Chip  label={tag.tagName}
                  avatar={<Avatar style={{backgroundColor:tag.tagColor, color:"rgb(0,0,0,0.60"}}>{tag.tagName.substring(0,1)}</Avatar>}
            />)

  }

  render(){
    const { theme, handleSubmit, isEditing } = this.props
    const title = isEditing?"Editar Notificación":"Crear Notificación"
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Crear Notificaciones</Typography>
            <Typography variant="subtitle1">Crea Notificaciones</Typography>
          </Box>
        </Box>
        <Container>        
          <Paper >
            <Typography style={theme.paper.title} variant="h2">{title}</Typography>
            <form style={theme.paper.form}>
              <Grid container xs={12} spacing={3} direction="row">
                <Grid item xs={6}>
                  <Field
                    component={TextField}
                    name="tskParams.title"
                    label="Título de la notificación"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="tskRunDate"
                    label="Fecha a notificar"
                    type="datetime-local"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    validate={this.props.isImmediate?undefined:[required]}
                    disabled={this.props.isImmediate}
                  />
                  <Field
                    component={({ input, label }) => (
                      <FormControlLabel label={label}
                          control={
                              <Checkbox
                                color="primary"
                                checked={input.value}
                                onChange={input.onChange}
                              />
                          }
                        />
                      )
                    }
                    name="tskImmediate"
                    label="Envío inmediato"
                    // type="datetime-local"
                    // InputLabelProps={{ shrink: true }}
                    // fullWidth
                    // validate={[required]}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Autocomplete  
                    options={this.props.tagList}
                    value={this.state.tagsSelected}
                    getOptionLabel={option=>option.tagName}
                    // filterOptions={(options, params) => {
                    //   const filtered = filterTag(options, params);
                    //   if (params.inputValue !== '') {
                    //     filtered.unshift({
                    //       inputValue: params.inputValue,
                    //       tagName: `Agregar "${params.inputValue}"`,
                    //     });
                    //   }
                    //   return filtered;
                    // }}
                    renderInput={params=><TextField {...params} fullWidth label="Seleccionar tags" helperText="Si no selecciona ningún tag se enviará la notificación a todos los usuarios."/>}
                    renderOption={(t)=>
                      <ListItem>
                        <ListItemIcon><TagIcon style={{color:t.tagColor}}/></ListItemIcon>
                        <ListItemText primary={t.tagName}/>
                      </ListItem>
                    }
                    renderTags={this.renderTags}
                    onChange={this.onSelectTag}
                    // onInputChange={this.onInputChangeTag}
                    loadingText="Cargando tags ..."
                    noOptionsText="Sin tags"
                    selectOnFocus
                    multiple
                    filterSelectedOptions
                  />
                </Grid>
              </Grid>
              <Grid container direction="row" spacing={3}>
                  <Grid item xs={8}>
                    <Field
                      component={TextField}
                      name="tskParams.body"
                      label="Cuerpo de la notificación"
                      fullWidth
                      multiline
                      rows={4}
                      validate={[required]}
                    />
                </Grid>
              </Grid>
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.onClean}>Limpiar</Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.props.history.goBack}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button variant="contained" color="primary" style={theme.footer.button} onClick={handleSubmit(this.onSave)}>Guardar</Button>
            </Tooltip>
          </Toolbar>
        </Container>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  console.log("STORE EVENT", store)
  return {
    login: store.auth.login,
    notification: store.ntf.notification,
    tagList: store.tag.tagList,
    isImmediate: store.form&&store.form.addEditNotifications&&store.form.addEditNotifications.values.tskImmediate

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionSaveNotification,
      actionGetTags
    },
    dispatch
  );
}

export default  reduxForm({
  form: "addEditNotifications",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AddEditNotifications)
    )
  )
)


// WEBPACK FOOTER //
// ./src/screens/notifications/AddEditNotifications.js